<template>
  <img src="@/assets/logo.png" alt="" class="w-10 h-10" />
</template>

<script>
export default {
  name: "logo"
};
</script>
